import { render, staticRenderFns } from "./DropdownItem.vue?vue&type=template&id=0887cf61&scoped=true"
import script from "./DropdownItem.vue?vue&type=script&lang=js"
export * from "./DropdownItem.vue?vue&type=script&lang=js"
import style0 from "../../theme/dropdown-item.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./DropdownItem.vue?vue&type=style&index=1&id=0887cf61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0887cf61",
  null
  
)

export default component.exports